<app-legal-layout [title]="title" [lastUpdated]="lastUpdated">
  <h2>1. Aceptación de los Términos</h2>
  <p>
    Al acceder y utilizar el sitio web de <strong>velas.ar</strong>, usted acepta estar sujeto a estos Términos y Condiciones. 
    Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestro sitio web ni nuestros servicios.
  </p>

  <h2>2. Información de la Empresa</h2>
  <ul>
    <li><strong>Nombre:</strong> velas.ar</li>
    <li><strong>Ubicación:</strong> Baradero, Buenos Aires, Argentina</li>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
  </ul>

  <h2>3. Uso del Sitio Web</h2>
  <p>Usted se compromete a utilizar nuestro sitio web de manera lícita y de acuerdo con estos términos. Específicamente:</p>
  <ul>
    <li>No utilizar el sitio para fines ilegales o no autorizados</li>
    <li>No intentar obtener acceso no autorizado al sitio o sistemas relacionados</li>
    <li>No interferir con la seguridad o funcionalidad del sitio</li>
    <li>No transmitir virus, malware u otro código dañino</li>
    <li>Respetar los derechos de propiedad intelectual</li>
  </ul>

  <h2>4. Productos y Precios</h2>
  <h3>4.1. Descripción de Productos</h3>
  <p>
    Nos esforzamos por garantizar que las descripciones de nuestros productos sean precisas. Sin embargo, no garantizamos que todas las descripciones, 
    imágenes u otra información sean completamente exactas, completas, fiables, actuales o libres de errores.
  </p>

  <h3>4.2. Precios</h3>
  <ul>
    <li>Todos los precios están expresados en pesos argentinos (ARS)</li>
    <li>Los precios están sujetos a cambios sin previo aviso</li>
    <li>El precio que paga es el precio vigente al momento de confirmar su pedido</li>
    <li>Los impuestos aplicables se agregarán durante el proceso de pago</li>
  </ul>

  <h2>5. Pedidos y Pagos</h2>
  <h3>5.1. Realización de Pedidos</h3>
  <ul>
    <li>Al realizar un pedido, realiza una oferta para comprar productos</li>
    <li>Nos reservamos el derecho de aceptar o rechazar cualquier pedido</li>
    <li>Recibirá una confirmación por correo electrónico cuando procesemos su pedido</li>
  </ul>

  <h3>5.2. Métodos de Pago</h3>
  <p>Aceptamos los siguientes métodos de pago:</p>
  <ul>
    <li>Transferencia bancaria</li>
    <li>Tarjetas de crédito y débito</li>
    <li>Mercado Pago</li>
    <li>Otros métodos de pago digitales</li>
  </ul>

  <h2>6. Envíos y Entregas</h2>
  <h3>6.1. Zonas de Envío</h3>
  <ul>
    <li><strong>Buenos Aires:</strong> Capital y Gran Buenos Aires</li>
    <li><strong>Baradero:</strong> Entrega local</li>
    <li><strong>Argentina:</strong> Envío nacional a todo el país</li>
  </ul>

  <h3>6.2. Tiempos de Entrega</h3>
  <ul>
    <li>Los tiempos de entrega son estimados y pueden variar</li>
    <li>Procesaremos su pedido dentro de 3-5 días hábiles</li>
    <li>Los tiempos de entrega finales dependen de la empresa de transporte</li>
    <li>Le proporcionaremos un número de seguimiento cuando su pedido sea despachado</li>
  </ul>

  <h3>6.3. Costos de Envío</h3>
  <p>Los costos de envío se calcularán durante el proceso de compra y variarán según el destino y el peso del pedido.</p>

  <h2>7. Devoluciones y Reembolsos</h2>
  <p>
    Consulte nuestra <a routerLink="/devoluciones">Política de Devoluciones</a> para obtener información detallada sobre devoluciones, 
    cambios y reembolsos.
  </p>

  <h2>8. Propiedad Intelectual</h2>
  <p>
    Todo el contenido del sitio web, incluyendo textos, gráficos, logotipos, iconos, imágenes, clips de audio, descargas digitales y compilaciones 
    de datos, es propiedad de velas.ar o sus proveedores de contenido y está protegido por las leyes de derechos de autor de Argentina.
  </p>

  <h2>9. Limitación de Responsabilidad</h2>
  <p>
    En la máxima medida permitida por la ley, velas.ar no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo 
    resultante del uso o la imposibilidad de usar nuestros productos o servicios.
  </p>

  <h2>10. Fuerza Mayor</h2>
  <p>
    No seremos responsables de cualquier retraso o incumplimiento de nuestras obligaciones si dicho retraso o incumplimiento resulta de circunstancias 
    fuera de nuestro control razonable, incluidos desastres naturales, guerras, terrorismo o pandemias.
  </p>

  <h2>11. Modificaciones de los Términos</h2>
  <p>
    Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios entrarán en vigencia inmediatamente 
    después de su publicación en el sitio web. Es su responsabilidad revisar periódicamente estos términos.
  </p>

  <h2>12. Ley Aplicable y Jurisdicción</h2>
  <p>
    Estos Términos y Condiciones se rigen por las leyes de la República Argentina. Cualquier disputa relacionada con estos términos será 
    sometida a la jurisdicción exclusiva de los tribunales de Buenos Aires, Argentina.
  </p>

  <h2>13. Contacto</h2>
  <p>Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos:</p>
  <ul>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
    <li><strong>WhatsApp:</strong> <a href="https://wa.me/5493329564190">+54 9 3329-564190</a></li>
  </ul>

  <p style="margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #ad5d56;">
    <strong>Al utilizar nuestro sitio web y realizar pedidos, usted acepta estar sujeto a estos Términos y Condiciones.</strong>
  </p>
</app-legal-layout>

